import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { Table, Tag } from "antd";
import { showConfirmDlgWidget } from "components/ConfirmDlgWidget/showConfirmDlgWidget";
import dragula from "dragula";
import "dragula/dist/dragula.css";
import { apiUpdateShopCategoryPosition } from "services/shopCategoryService";
import { DragOutlined } from "@ant-design/icons";

const getIndexInParent = (el) => Array.from(el.parentNode.children).indexOf(el);

const stripHtml = (html) => {
  const tmp = document.createElement("DIV");
  tmp.innerHTML = html || "";
  return tmp.textContent || tmp.innerText || "";
};

function TableWidget(props) {
  const [dataSource, setDataSource] = useState([]);
  const { dataList, onUpdateAction, onDeleteAction } = props;

  useEffect(() => {
    let start;
    let end;
    const container = document.querySelector(".ant-table-tbody");
    const drake = dragula([container], {
      moves: (el) => {
        start = getIndexInParent(el);
        return true;
      },
    });
    drake.on("drop", (el) => {
      end = getIndexInParent(el);
      handleReorder(start, end);
    });
  }, []);

  useEffect(() => {
    if (dataList !== undefined) {
      setDataSource([
        ...dataList.map((info) => {
          return { ...info, key: info.id, icon: <DragOutlined type="swap" /> };
        }),
      ]);
    }
  }, [dataList]);
  if (dataList === undefined) return <div />;

  const columns = [
    {
      title: <DragOutlined type="swap" />,
      dataIndex: "icon",
    },
    {
      title: "ID",
      dataIndex: "id",
    },
    {
      title: "Name",
      dataIndex: "name",
      align: "center",
      sorter: {
        compare: (a, b) => stripHtml(a.name).localeCompare(stripHtml(b.name)),
      },
      render: (text, record) => <div>{stripHtml(record.name)}</div>,
    },
    {
      title: "Publish",
      dataIndex: "status",
      align: "center",
      render: (text, record) => {
        return (
          <Tag
            color={
              record.status === "1" ? "var(--blueColor)" : "var(--orangeColor)"
            }
          >
            {record.status === "1" ? "Yes" : "No"}
          </Tag>
        );
      },
    },
    {
      title: "Updated At",
      dataIndex: "update_timestamp",
      align: "center",
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (text, record) => {
        return (
          <div>
            <a
              style={{ color: "var(--orangeColor)", marginLeft: 20 }}
              className="edit-btn"
              onClick={() => onUpdateAction(record)}
            >
              Edit
            </a>
            <a
              style={{ color: "var(--redColor)", marginLeft: 20 }}
              className="del-btn"
              onClick={async () => {
                var res = await showConfirmDlgWidget({
                  title: "Delete Confirmation",
                  content: "Are you sure to delete this record?",
                });
                if (res == false) return;
                onDeleteAction(record);
              }}
            >
              Delete
            </a>
          </div>
        );
      },
    },
  ];

  const handleReorder = (dragIndex, draggedIndex) => {
    setDataSource((oldState) => {
      const newState = [...oldState];
      const item = newState.splice(dragIndex, 1)[0];
      newState.splice(draggedIndex, 0, item);
      apiUpdateShopCategoryPosition(newState);
      return newState;
    });
  };

  return (
    <div className="list-table">
      <Table pagination={false} columns={columns} dataSource={dataSource} />
    </div>
  );
}

export default withRouter(TableWidget);
